import BaseElement from '../structure/BaseElement';
import merge from 'lodash/merge';

/**
 * @property {String} value
 * @property {String} comparator
 * @property {String} unit
 * @property {String} system
 * @property {String} code
 */
export default class Quantity extends BaseElement {
    static __className = 'Quantity';

    __objectStructure = {
        value: String,
        comparator: String,
        unit: String,
        system: String,
        code: String,
    };

    constructor(constructJson, className = 'Quantity') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
